import { showToast } from "./feedback.js";

function toast(message, options) {
  return showToast(message, options);
}

export default toast;
